import ManualLinkSetup from '@monetr/interface/components/setup/manual/ManualLinkSetup';

export default function CreateManualLinkPage(): JSX.Element {
  return <ManualLinkSetup />;
}
